import { useCallback, useEffect, useState } from "react";

import { toast } from "sonner";

import { api } from "@/api";

export default function ContactRequestsPage() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/contact-requests").then(({ data }) => setItems(data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const retry = async (r) => { try { await api.post(`/contact-requests/${r.id}/nocrm`); toast.success("Lead créé dans noCRM"); } catch (e) { toast.error(e.response?.data?.detail || "Échec de l'envoi vers noCRM"); } load(); };
  const toggle = async (r) => { await api.patch(`/contact-requests/${r.id}`, { status: r.status === "traite" ? "nouveau" : "traite" }); load(); };
  return (
    <section className="page" data-testid="contact-requests-page">
      <header className="page-heading"><div><p className="eyebrow">MARKETING</p><h1>Demandes du site</h1><p className="page-subtitle">Les demandes envoyées depuis le formulaire du site vitrine.</p></div></header>
      <div className="agent-table-wrap">
        <table className="agent-table" data-testid="contact-requests-table">
          <thead><tr><th>Date</th><th>Contact</th><th>Structure</th><th>Bâtiment</th><th>Message</th><th>noCRM</th><th>Statut</th></tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={7} className="agent-name-cell">Aucune demande pour l'instant.</td></tr>}
            {items.map((r) => (
              <tr key={r.id} data-testid={`contact-request-${r.id}`}>
                <td>{new Date(r.created_at).toLocaleString("fr-FR")}</td>
                <td className="agent-name-cell"><strong>{r.name}</strong><br /><a href={`mailto:${r.email}`}>{r.email}</a>{r.phone && <><br />{r.phone}</>}</td>
                <td className="agent-name-cell">{r.organisation || "—"}</td>
                <td className="agent-name-cell">{r.building_type || "—"}</td>
                <td className="agent-name-cell contact-msg">{r.message || "—"}</td>
                <td className="agent-name-cell" data-testid={`contact-nocrm-${r.id}`}>{r.nocrm_lead_id ? `Lead #${r.nocrm_lead_id}` : <button type="button" className="secondary-button" title={r.nocrm_error || ""} onClick={() => retry(r)} data-testid={`contact-nocrm-retry-${r.id}`}>{r.nocrm_error ? "Échec · Renvoyer" : "Envoyer"}</button>}</td>
                <td><button type="button" className={r.status === "traite" ? "secondary-button" : "primary-button"} onClick={() => toggle(r)} data-testid={`contact-status-${r.id}`}>{r.status === "traite" ? "Traité" : "Nouveau"}</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
